import { apiRequest } from './apiClient';

export const RANDEVU_BEDELI_SAYAC_YENILE_EVENT = 'randevu-bedeli-onay-bekleyen-refresh';

export const fetchRandevuBedelleri = async ({ sayfa = 1, limit = 20, arama, durum, hakedisiz, randevuId } = {}) => {
  const query = { sayfa, limit };
  if (arama) query.arama = arama;
  if (durum) query.durum = durum;
  if (hakedisiz !== undefined) query.hakedisiz = hakedisiz;
  if (randevuId) query.randevuId = randevuId;
  const response = await apiRequest('/api/randevu-bedelleri', { method: 'GET', query });
  return response;
};

export const fetchRandevuBedeliOnayBekleyenSayisi = async () => {
  const response = await fetchRandevuBedelleri({ durum: 'OnayBekliyor', sayfa: 1, limit: 1 });
  return response?.veri?.sayfalama?.toplam ?? 0;
};

export const fetchRandevuBedeliOnaylandiSayisi = async () => {
  const response = await fetchRandevuBedelleri({ durum: 'Onaylandi', sayfa: 1, limit: 1 });
  return response?.veri?.sayfalama?.toplam ?? 0;
};

export const fetchRandevuBedelleriHakedisiz = async () => {
  const response = await apiRequest('/api/randevu-bedelleri/hakedisiz', { method: 'GET' });
  return response;
};

/**
 * Hakedişe eklenmemiş randevu bedelleri, belirli teknik servise göre (modal 2. adım)
 */
export const fetchRandevuBedelleriHakedisizByTeknikServis = async (teknikServisId) => {
  const query = teknikServisId ? { teknikServisId: String(teknikServisId).trim() } : {};
  const response = await apiRequest('/api/randevu-bedelleri/hakedisiz', { method: 'GET', query });
  return response;
};

export const fetchRandevuBedeliDetay = async (id) => {
  const response = await apiRequest(`/api/randevu-bedelleri/${id}`, { method: 'GET' });
  return response;
};

export const randevuBedeliOnayla = async (id, { satirlar, yolBedeli, mesafe }) => {
  const response = await apiRequest(`/api/randevu-bedelleri/${id}/onayla`, {
    method: 'PATCH',
    body: { satirlar, yolBedeli, mesafe },
  });
  return response;
};

/**
 * Randevu bedelini iptal et (Admin — yalnızca OnayBekliyor)
 */
export const randevuBedeliIptal = async (id) => {
  const response = await apiRequest(`/api/randevu-bedelleri/${id}/iptal`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

export const hakedisOlusturFromBedeller = async (randevuBedeliIds) => {
  const response = await apiRequest('/api/hakedisler', {
    method: 'POST',
    body: { randevuBedeliIds },
  });
  return response;
};
